import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MiscService, VisitorPsyFollowUpService } from '@services/index';

declare var swal: any;

@Component({
    selector: 'app-util-visitor-parts-medical-follow-up-list',
    templateUrl: './list.component.html',
})
export class UtilVisitorPartsMedicalFollowUpListComponent implements OnInit {
    @Input() visitor: any = null;
    @Output() updateEvent = new EventEmitter();

    isLoading = true;
    isLoadingVisitors = false;
    selfVisitor = false;
    filter: any = {
        date_begin: null,
        date_end: null
    };
    limit = 20;
    page = 1;
    visitorPsyFollowUps: any;
    hasData = {
        visitorPsyFollowUps: false
    };

    constructor(private cdref: ChangeDetectorRef,
                private miscService: MiscService,
                private visitorPsyFollowUpService: VisitorPsyFollowUpService) {}

    ngOnInit() {
        this.miscService.can("getVisitorPsychoFollowUp");
        this.isLoading = true;
        this.selfVisitor = this.miscService.checkDataLength(this.visitor) ? true : false;
        this.getVisitorsPsyFollowUps();
        this.cdref.detectChanges();
    }

    filterVisitorMedicalFollowUps(filter = null) {
        this.filter = filter;
        this.getVisitorsPsyFollowUps(true);
    }

    getVisitorsPsyFollowUps(hasFilter = false) {
        this.isLoading = true;
        let data = this.filter;
        data.visitor_ids = this.selfVisitor ? [this.visitor.id] : (data.visitor_ids && data.visitor_ids.length ? data.visitor_ids : null);
        data.limit = this.limit;
        data.page = !hasFilter ? this.page : 1;     // if user has filtered, then reset page to 1 (number of pages can change due to filters)
        this.visitorPsyFollowUpService.getByVisitors(data).subscribe(data => {
            this.visitorPsyFollowUps = data;
            this.hasData.visitorPsyFollowUps = this.miscService.checkDataLength(this.visitorPsyFollowUps.data);
            this.isLoading = false;
        }, error => {
            this.visitorPsyFollowUps = null;
            this.hasData.visitorPsyFollowUps = false;
            this.miscService.showMsg({ msg: "VISITOR_PSY_FOLLOW_UPS_NOT_FOUND_PLEASE_CHECK_FILTERS" });
            this.isLoading = false;
        });
    }
    
    addFollowUp() {
        this.getVisitorsPsyFollowUps();
        this.updateEvent.emit();
    }

    switchPage(page) {
        this.page = page;
        this.getVisitorsPsyFollowUps();
    }

    delete(visitorPsyFollowUp) {
        let self = this;
        let title = this.miscService._t('VISITORS_PSY_FOLLOW_UPS.DELETE_FOLLOW_UP') + " ?";
        swal({
            title: title,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this.miscService._t('SHARED.CONFIRM'),
            cancelButtonText: this.miscService._t('SHARED.CANCEL'),
            closeOnConfirm: true,
            closeOnCancel: true,
        }, function(isConfirm) {
            if(isConfirm) {
                self.visitorPsyFollowUpService.delete(visitorPsyFollowUp.id).subscribe(data => {
                    self.getVisitorsPsyFollowUps(true);  // resets page to 1 (in case of there is only 1 visitor follow up on the current page)
                    self.miscService.showMsg({ msg: "VISITOR_PSY_FOLLOW_UP_DELETED", status: "success" });
                    self.updateEvent.emit();
                }, error => {
                    self.miscService.showMsg({ msg: "VISITOR_PSY_FOLLOW_UP_NOT_DELETED" });
                });
            }
        });
    }
}
